import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

import { useDeliveryLocations } from "../useDeliveryLocations";
import { requestCreateDeliveryLocation } from "./deleteDeliveryLocation.request";
import { DeleteDeliveryLocationBody } from "./deleteDeliveryLocation.types";

const useDeleteDeliveryLocation = (
  options?: MutationOptions<
    void,
    ApiServiceError<ApiError>,
    DeleteDeliveryLocationBody
  >
) => {
  const { t } = useTranslation();

  const { refetch: refetchDeliveryLocations } = useDeliveryLocations({
    enabled: false
  });

  return useMutation({
    mutationFn: requestCreateDeliveryLocation,
    ...options,
    onSuccess: (data, variables, context) => {
      const getToastMessage = () => {
        if (variables.areaName) {
          return t("Area deleted successfully");
        }

        if (variables.cityName) {
          return t("City deleted successfully");
        }

        return t("Country deleted successfully");
      };

      refetchDeliveryLocations();
      toast.success(getToastMessage());
      options?.onSuccess?.(data, variables, context);
    }
  });
};

export default useDeleteDeliveryLocation;
